import type { ReactNode } from "react";
import { useModuleBEM } from "@b2bportal/core-themes";
import clsx from "clsx";
import styles from "./SectionTitle.module.scss";

export interface SectionTitleProps {
  children: ReactNode;
  className?: string;
  as?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
}

export const SectionTitle = ({
  children,
  className,
  as: Component = "h2",
}: SectionTitleProps) => {
  const [block] = useModuleBEM(styles, "SectionTitle");

  return <Component className={clsx(block, className)}>{children}</Component>;
};
